import { z } from 'zod';

export const orderProductSizeSnapshotSchema = z.object({
    name: z.string(),
    slug: z.string(),
    sizeLabel: z.string(),
    imageKey: z.string().nullable(),
    imageAlt: z.string().nullable(),
    imageHeight: z.number().nullable(),
    imageThumbhash: z.string().optional(),
});

export type OrderProductSizeSnapshotSchema = z.infer<typeof orderProductSizeSnapshotSchema>;
